import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./fonts.css";
import "./index.css";

// Import data prefetch to start fetching immediately (before React renders)
import "./lib/dataPrefetch";

// 🎮 Hidden developer console message
console.log(
  `%c
╔═══════════════════════════════════════════╗
║                                           ║
║   👋 Hey there, curious developer!        ║
║                                           ║
║   Built with ❤️ by Akith Chandinu          ║
║                                           ║
║   🎮 Psst... try the Konami code          ║
║   ↑ ↑ ↓ ↓ ← → ← → B A                     ║
║                                           ║
╚═══════════════════════════════════════════╝
`,
  "color: #4ECDC4; font-family: monospace; font-size: 12px;",
);

createRoot(document.getElementById("root")!).render(<App />);
